/* tslint:disable */

declare var Object: any;
export interface SourceInterface {
  "sfdcId"?: string;
  "Active__c"?: boolean;
  "Cost__c"?: number;
  "Descrition__c"?: any;
  "End_Date__c"?: Date;
  "ExternalID__c"?: string;
  "General_Source_Type__c"?: string;
  "Source_Email__c"?: string;
  "Start_Date__c"?: Date;
  "TXT_Key__c"?: string;
  "View_on_Job_Board__c"?: boolean;
  "Name"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Source implements SourceInterface {
  "sfdcId": string;
  "Active__c": boolean;
  "Cost__c": number;
  "Descrition__c": any;
  "End_Date__c": Date;
  "ExternalID__c": string;
  "General_Source_Type__c": string;
  "Source_Email__c": string;
  "Start_Date__c": Date;
  "TXT_Key__c": string;
  "View_on_Job_Board__c": boolean;
  "Name": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: SourceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Source`.
   */
  public static getModelName() {
    return "Source";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Source for dynamic purposes.
  **/
  public static factory(data: SourceInterface): Source{
    return new Source(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Source',
      plural: 'Sources',
      path: 'Sources',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Active__c": {
          name: 'Active__c',
          type: 'boolean'
        },
        "Cost__c": {
          name: 'Cost__c',
          type: 'number'
        },
        "Descrition__c": {
          name: 'Descrition__c',
          type: 'any'
        },
        "End_Date__c": {
          name: 'End_Date__c',
          type: 'Date'
        },
        "ExternalID__c": {
          name: 'ExternalID__c',
          type: 'string'
        },
        "General_Source_Type__c": {
          name: 'General_Source_Type__c',
          type: 'string'
        },
        "Source_Email__c": {
          name: 'Source_Email__c',
          type: 'string'
        },
        "Start_Date__c": {
          name: 'Start_Date__c',
          type: 'Date'
        },
        "TXT_Key__c": {
          name: 'TXT_Key__c',
          type: 'string'
        },
        "View_on_Job_Board__c": {
          name: 'View_on_Job_Board__c',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
